var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewer",class:{padding: _vm.viewerConfig.showSidebar}},[_c('iframe',{staticClass:"full",attrs:{"src":_vm.srcHref}},[_vm._v(" Oops! an error has occurred. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }